var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _mask, _g, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionEmptyStateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 346 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.044 187.177c-.4.001-.602-.197-.603-.593L.001 31.125c0-.396.2-.594.6-.595l230.363-.652c.401 0 .602.197.603.593l.44 155.459c.001.396-.199.595-.6.596l-230.363.651z",
    fill: "#E9FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.422 186.715c-.348.001-.523-.182-.524-.551l-.17-60.192c-.001-.368.173-.553.521-.554l46.631-.131c.348-.001.522.182.523.55l.17 60.193c.002.368-.172.552-.52.553l-46.631.132zM164.192 104.986c-.348.001-.522-.101-.522-.305l-.095-33.44c0-.205.173-.308.521-.309l46.631-.132c.348 0 .523.101.523.306l.095 33.44c0 .204-.173.307-.521.308l-46.632.132zM89.652 212.401c-.398.001-.597-.156-.598-.473l-.146-51.769c-.001-.317.197-.476.595-.477l53.293-.151c.397-.001.597.157.598.474l.146 51.769c.001.317-.198.475-.595.477l-53.293.15zM89.445 139.25c-.397.001-.597-.203-.598-.612l-.189-66.88c-.001-.409.197-.614.595-.615l53.293-.15c.397-.002.597.202.598.611l.189 66.88c.001.409-.197.615-.595.616l-53.293.15zM21.396 187.119c-.348.001-.523-.101-.523-.306l-.095-33.44c0-.204.173-.307.521-.308l46.632-.132c.348-.001.522.101.522.305l.095 33.441c0 .204-.173.307-.521.308l-46.631.132zM21.242 132.633c-.348.001-.522-.182-.523-.551l-.17-60.192c-.002-.368.172-.553.52-.554l46.631-.131c.348-.001.523.182.524.55l.17 60.193c0 .368-.173.552-.52.553l-46.632.132z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.469 49.602l70.491-.2",
    stroke: "#fff",
    strokeWidth: 4.239,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.262 20.452c14.725-10.353 33.925-9.964 50.897-5.382 16.703 4.508 32.497 12.713 46.103 23.961 12.217 10.101 22.786 22.677 36.392 30.502 10.679 6.13 23.086 12.344 35.593 12.797 6.094.222 12.278-1.063 17.033-5.445 4.735-4.36 10.619-14.903 6.104-21.139-3.896-5.36-12.098-3.065-17.163 1.148-6.653 5.54-11.358 13.335-15.274 21.318-9.35 19.064-14.905 39.918-21.947 60.067-7.832 22.413-17.552 44.089-29.02 64.658-5.045 9.058-10.56 18.064-18.202 24.72-6.753 5.877-15.044 9.711-23.645 10.933-11.618 1.653-23.966-1.696-32.667-9.995-8.701-8.3-13.256-21.645-10.589-33.883 2.668-12.229 12.977-22.477 24.665-23.382",
    stroke: "#0DA8D4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 48.1h-.7c-1.8 0-3.2-1.4-3.2-3.2v-1.7c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v1.7c0 1.8-1.4 3.2-3.2 3.2h-.7c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h.7c1.8 0 3.2 1.4 3.2 3.2v2.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.2c0-1.8 1.4-3.2 3.2-3.2h.7c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2zM259.8 31.1h-.5c-1.2 0-2.2-1-2.2-2.2v-1.1c0-.4-.4-.8-.8-.8s-.8.4-.8.8V29c0 1.2-1 2.2-2.2 2.2h-.5c-.4 0-.8.4-.8.8s.4.8.8.8h.5c1.2 0 2.2 1 2.2 2.2v1.5c0 .4.4.8.8.8s.8-.4.8-.8V35c0-1.2 1-2.2 2.2-2.2h.5c.4 0 .8-.4.8-.8.1-.6-.3-.9-.8-.9z",
    fill: "#7FD8EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.352 150.049l36.15 45.45c-1.5 4.5-4.9 14.4-6.5 18-1.6 3.6-11.667 13.5-16.5 18l-13.15-8.46h-4.71c-3.73 0-7.39-.97-10.63-2.82l-.84-.48c-14.32 3.06-25.14-12.65-35.01-33.52-9.54 1.07-18.6-1.05-27.37-5.16a8.191 8.191 0 01-5.92-4.65l-20.21-44.54 18.17-28.06 7.43-2.15.66-2.64-16.35-4.82-11.4-25.07s3.75-4.95 6.61-5.61c1.71-.4 26.05 9.66 32.51 12.14 1 .38 2.04.65 3.09.82 9.08 1.49 17.24 3.82 24.51 6.98 1.84.8 3.48 1.97 4.79 3.49 3.47 4.03 6.57 9.33 8.08 13.89 4.87 13.92 15.91 31.68 26.59 49.21z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 199.5l7 8",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M330.247 188.332c5.002-4.222 8.961-6.166 10.715-4.844 3.55 2.676-3.281 17.722-15.257 33.607-11.976 15.885-24.561 26.593-28.111 23.916-2.116-1.595-.542-7.589 3.613-15.536",
    stroke: "#2BB3D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.502 192.499l-33.15-42.45c-10.68-17.53-21.72-35.29-26.59-49.21-1.51-4.56-4.61-9.86-8.08-13.89-1.31-1.52-2.95-2.69-4.79-3.49-7.27-3.16-15.43-5.49-24.51-6.98-1.05-.17-2.09-.44-3.09-.82-6.46-2.48-30.8-12.54-32.51-12.14-2.86.66-6.61 5.61-6.61 5.61l11.4 25.07 16.35 4.82-.66 2.64-7.43 2.15-18.17 28.06 20.21 44.54a8.191 8.191 0 005.92 4.65c8.77 4.11 17.83 6.23 27.37 5.16 9.87 20.87 20.69 36.58 35.01 33.52l.84.48c3.24 1.85 6.9 2.82 10.63 2.82h4.71l18.78 14.83",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.129 171.129c.18.18 2.53 3.28 4.56 5.98 1.31 1.74 4.02 1.33 4.76-.71l.77-2.1M232.422 119.66s2.04-7.42 6.99-17.5c0 0-.5-5.61.83-7.76M220.922 99.02s1.82-7.93 8.26-9.41M208.502 97.64s-2.11-17.51-6.58-25.21",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M244.759 158.029l-52.04 32.81c-2.69 1.69-6.24.89-7.93-1.8l-57.15-90.67c-1.69-2.69-.89-6.24 1.8-7.93l52.04-32.8c2.69-1.69 6.24-.89 7.93 1.8l57.15 90.67c1.7 2.68.89 6.23-1.8 7.92z",
    fill: "#FDE19C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.008 78.738l-14.442 9.104 63.292 100.403 14.442-9.103-63.292-100.404z",
    fill: "#23547B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.149 131.205l-9.524 6.004 16.657 26.423 9.524-6.004-16.657-26.423z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 78,
    width: 79,
    height: 111
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.004 78.738l-14.442 9.104 63.293 100.403 14.441-9.103-63.292-100.404z",
    fill: "#23547B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.266 119.688l-22.695 13.559 1.533 8.545 22.695-13.559-1.533-8.545zM176.198 112.083l-22.695 13.56.121 3.208 22.696-13.559-.122-3.209zM173.764 106.333l-22.695 13.56.122 3.208 22.695-13.559-.122-3.209z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.72 190.839l52.04-32.81c2.69-1.69 3.5-5.24 1.8-7.92l-57.15-90.67c-1.69-2.69-5.24-3.49-7.93-1.8l3.31 131.4c1.69 2.69 5.24 3.49 7.93 1.8z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.921 130.62c-5.06-2-10.33-4.07-15.63-6.17-5.29-.71-14.87-11.36-24.89-23.05a25.018 25.018 0 00-7.56-5.96c-8.64-4.46-17.75-10.01-27.33-16.62-.62-.43-1.44-.46-2.09-.08-4.51 2.61-6.29 7.18-3.9 14.77.39 1.25.7 2.52.98 3.8.49 2.23 1.5 4.67 2.88 7.28 3.27 6.15 8.17 11.27 13.99 15.11 12.15 8.01 23.13 16.69 28.71 28.43 1.61 3.39 4.13 39.52 57.86 59.56",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.312 94.4c-1.18 6.1-5.03 8.44-9.27 10.24-6-2.15-10.79-6.17-14.37-12.06",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M255.921 130.62c-5.06-2-10.33-4.07-15.63-6.17-5.29-.71-14.87-11.36-24.89-23.05a25.018 25.018 0 00-7.56-5.96c-8.64-4.46-17.75-10.01-27.33-16.62-.62-.43-1.44-.46-2.09-.08-4.51 2.61-6.29 7.18-3.9 14.77.39 1.25.7 2.52.98 3.8.49 2.23 1.5 4.67 2.88 7.28 3.27 6.15 8.17 11.27 13.99 15.11 12.15 8.01 23.13 16.69 28.71 28.43 1.61 3.39 4.13 39.52 57.86 59.56",
    stroke: "#23547B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionEmptyStateImage);
export default __webpack_public_path__ + "static/media/transaction-empty-state-image.9f839097ddace1b80c4df9b459a93f9d.svg";
export { ForwardRef as ReactComponent };